module.exports = __webpack_public_path__ + "img/home_slider_09.92096c0c.jpg";